// extracted by mini-css-extract-plugin
export default {"blocker":"styles_blocker__slgPZ","spinner":"styles_spinner__gyIB7"};